module.exports = __webpack_public_path__ + "static/second_user_image3-eb6ae99b9a99bf4060f94fddeae0eb33.jpg";